// @flow
import { styled } from 'mz-ui-kit'

export const Container = styled<{ $showed: boolean }>('div', ({ $showed }) => ({
  position: 'fixed',
  width: '100%',
  height: '100%',
  left: 0,
  top: 0,
  transform: 'translate3d(0,0,0)',
  pointerEvents: $showed ? 'auto' : 'none',
}))
